import { render, staticRenderFns } from "./totalServiceTime.vue?vue&type=template&id=d554aca0"
import script from "./totalServiceTime.vue?vue&type=script&lang=js"
export * from "./totalServiceTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports